import { axios } from '@lib/axios';

import {
    MessageListResponse,
    MessageListQuery,
    SendMessageParams,
    SendManualMessageParams,
    SendEntryToEmailData,
    ManualTemplateNames,
} from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api';

export class NotificationApi {
    public static async getList(params: MessageListQuery = {}): Promise<MessageListResponse> {
        const res = await axios.get(`${BASE_URL}/message`, { params });
        return res.data;
    }

    public static async sendMessage(message: SendMessageParams): Promise<void> {
        await axios.post(`${BASE_URL}/message`, { message });
    }

    public static async sendEntryToEmail({ entryId, email }: SendEntryToEmailData): Promise<void> {
        await axios.post(`${BASE_URL}/message/entry/${entryId}`, { email });
    }

    public static async sendManualMessage(
        templateName: ManualTemplateNames,
        params: SendManualMessageParams,
    ): Promise<void> {
        await axios.post(`${BASE_URL}/notification/template/${templateName}/message`, params);
    }
}
